<template>
  <v-flex xs12 md6 lg4 xl3 px-2 mb-2 class="on-white-background">
    <v-hover>
      <v-card
        class="px-4 py-2 mb-2 rounded-3 elevation-2 cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 3 : 0}`">
        <router-link 
          class="no-link-style" 
          :to="{ 
            name: 'Email', 
            params: {
              case_type_id: template.caseTypeId,
              email_id: template.id
            }
          }">
          <v-card-title class="pa-0 pb-2 pt-1">
            <v-flex xs12>
              <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">
                {{ template.name }}
                <v-chip 
                  v-if="template.defaultEmailBodyTemplate"
                  x-small 
                  color="primary" 
                  text-color="white"
                  class="ml-2">
                  Default
                </v-chip>
              </h3>
            </v-flex>
            <v-flex xs12 pr-4>
              <h4 class="text-truncate">
                <span class="primary--text body-1 opacity-54 pt-1">Response Template</span>
              </h4>
              <p v-if="template.caseTypeName" class="caption text--secondary mt-1 mb-0">
                {{ template.caseTypeName }}
              </p>
            </v-flex>
          </v-card-title>
        </router-link>
        <v-card-actions class="card-vert-menu">
          <v-menu
            left offset-y nudge-top="30px"
            origin="center center" transition="scale-transition">
            <v-btn
              flat icon dark small
              slot="activator" class="ma-0 mr-0 pa-0" color="secondary"
              style="margin-top:-3px !important; margin-left:-10px !important;"
              @click.prevent>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="navigateToEdit">
                <v-icon class="mr-2" color="secondary">edit</v-icon>Edit
              </v-list-tile>
              <v-list-tile @click="deleteDialog = true">
                <v-icon class="mr-2" color="error">remove_circle</v-icon>Delete
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-actions>
      </v-card>
    </v-hover>
    <delete-dialog 
      :isOpen="deleteDialog" 
      itemType="response template" 
      v-on:delete-item="deleteTemplate">
    </delete-dialog>
  </v-flex>
</template>

<script>
import DeleteDialog from "@/components/shared/deleteDialog"

export default {
  name: "ResponseTemplateCard",
  components: { DeleteDialog },
  props: ["template"],
  data() {
    return {
      deleteDialog: false
    }
  },
  methods: {
    navigateToEdit() {
      this.$router.push({ 
        name: 'Email', 
        params: {
          case_type_id: this.template.caseTypeId,
          email_id: this.template.id
        }
      })
    },
    deleteTemplate(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.$emit('removeTemplate', this.template)
      }
    }
  }
}
</script>

<style scoped>
.no-link-style {
  text-decoration: none;
  color: inherit;
}
</style>